/**
 * This functionality to change basic font family on the site.
 */
function setCustomFont() {
  const fontFamilySettings = window.globalSettings?.fontFamilyCustom;

  const fontValueClasses = {
    one: 'pmi-custom-font--open-sans',
    two: 'pmi-custom-font--malgun-gothic',
    three: 'pmi-custom-font--japan',
  };

  if (!!fontFamilySettings && !!fontValueClasses[fontFamilySettings]) {
    document.documentElement.classList.add(fontValueClasses[fontFamilySettings]);
  }
}

setCustomFont();
